import request from '@/utils/request'

// 根据付款单号，获取付款单信息
export function getPayOrderByCode(id) {
  return request({
    url: `/api/srm-finc/payApplyOrder/getPayOrderByCode/${id}`,
    method: 'get'
  })
}
